/**
 * VFXStore - Zustand store for managing VFX emitters and particle emission.
 */

import { createStore } from 'zustand/vanilla';

import type { EmitCallbackSettingsFn } from './core/VFXParticlesShared.js';

interface VFXStore {
  emitters: Record<string, (...args: any[]) => void>;
  shouldEmit: boolean;
  registerEmitter: (name: string, emitter: (...args: any[]) => void) => void;
  unregisterEmitter: (name: string) => void;
  emit: (name: string, rate: number, callback: EmitCallbackSettingsFn) => void;
}

export const vfxStore = createStore<VFXStore>((set: any, get: any) => ({
  emitters: {},
  shouldEmit: true,
  registerEmitter: (name: string, emitter: (...args: any[]) => void) => {
    if (get().emitters[name]) {
      console.warn(`Emitter ${name} already exists`);
      return;
    }
    set((state: VFXStore) => {
      state.emitters[name] = emitter;
      return state;
    });
  },
  unregisterEmitter: (name: string) => {
    set((state: VFXStore) => {
      delete state.emitters[name];
      return state;
    });
  },
  emit: (name: string, rate: number, callback: EmitCallbackSettingsFn) => {
    const emitter = get().emitters[name];
    if (!emitter) {
      console.warn(`Emitter ${name} not found`);
      return;
    }
    emitter(rate, callback);
  },
}));
